export default __webpack_public_path__ + "static/media/cancel.0c45c531.svg";